export class CellHistory {
}

export class CellHistoryRequest{
    "table":string;
    "keyColumn":string;
    "keyValue":number;
    "columnName":string;
    "title"?:string;
}